<template>
  <div class="mobile_change_making">
    <div class="mySwitch">
      <!-- 显示当前选中项的图片 -->
      <img
        v-if="currentItem"
        style="width: 315px; height: 192px; margin: 20px 0"
        :src="currentItem.url"
        alt=""
      />
      <!-- 显示当前选中项的文字信息 -->
      <div class="slider-container">
        <!-- 左箭头 -->
        <div
          class="arrow left"
          @click="moveLeft"
          :style="{
            opacity: currentIndex === 0 ? 0.3 : 1,
            display: currentIndex === 0 ? 'none' : 'block',
          }"
        >
          <i class="el-icon-arrow-left"></i>
        </div>
        <!-- 外部容器，固定宽度并溢出隐藏 -->
        <div class="outer-box" ref="outerBox">
          <!-- 内部容器，根据数据渲染 -->
          <div
            class="inner-box"
            ref="innerBox"
            :style="{ transform: `translateX(-${offset}px)` }"
          >
            <div
              v-for="item in navItems"
              :key="item.id"
              class="item"
              :class="{ active: currentItem && item.id === currentItem.id }"
              @click="selectItem(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
        <!-- 右箭头 -->
        <div
          class="arrow right"
          @click="moveRight"
          :style="{
            opacity: canScrollRight() ? 1 : 0.3,
            display: canScrollRight() ? 'block' : 'none',
          }"
        >
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="SwitchText" v-if="currentItem">{{ currentItem.msg }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navItems: [],
      currentIndex: 0,
      offset: 0,
      visibleItems: 0,
      currentItem: null,
      totalWidth: 0,
    };
  },
  props: {
    Info: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        this.currentItem = this.navItems[0];
        this.calculateVisibleItems();
        this.calculateTotalWidth();
      }
    });
  },
  methods: {
    moveLeft() {
      if (this.currentIndex > 0) {
        const prevItem = this.$refs.innerBox.children[this.currentIndex - 1];
        const moveWidth = prevItem.offsetWidth + 20;
        this.offset = Math.max(0, this.offset - moveWidth);
        this.currentIndex--;
      }
    },
    moveRight() {
      if (this.canScrollRight()) {
        const currentItem = this.$refs.innerBox.children[this.currentIndex];
        const moveWidth = currentItem.offsetWidth + 20;
        this.offset += moveWidth;
        this.currentIndex++;
      }
    },
    selectItem(item) {
      this.currentItem = item;
    },
    calculateVisibleItems() {
      if (this.$refs.innerBox && this.$refs.outerBox) {
        const outerBoxWidth = this.$refs.outerBox.offsetWidth;
        let totalWidth = 0;
        let visibleCount = 0;
        const items = this.$refs.innerBox.children;
        for (let i = 0; i < items.length; i++) {
          totalWidth += items[i].offsetWidth;
          if (i > 0) {
            totalWidth += 20;
          }
          if (totalWidth <= outerBoxWidth) {
            visibleCount++;
          } else {
            break;
          }
        }
        this.visibleItems = visibleCount;
      }
    },
    calculateTotalWidth() {
      if (this.$refs.innerBox) {
        let total = 0;
        const items = this.$refs.innerBox.children;
        for (let i = 0; i < items.length; i++) {
          total += items[i].offsetWidth;
          if (i > 0) {
            total += 20;
          }
        }
        this.totalWidth = total;
      }
    },
    getVisibleWidth() {
      return this.$refs.outerBox ? this.$refs.outerBox.offsetWidth : 0;
    },
    canScrollRight() {
      if (!this.$refs.innerBox) return false;
      const outerBoxWidth = this.getVisibleWidth();
      const lastItem =
        this.$refs.innerBox.children[this.$refs.innerBox.children.length - 1];
      const lastItemRight = this.totalWidth - lastItem.offsetWidth - 20;
      return (
        this.offset + outerBoxWidth < lastItemRight + lastItem.offsetWidth + 20
      );
    },
  },
  watch: {
    "$el.clientWidth": {
      handler() {
        this.calculateVisibleItems();
        this.calculateTotalWidth();
      },
      immediate: false,
    },
    Info: {
      immediate: true,
      handler(newValue) {
        this.navItems = newValue;

        if (this.navItems.length > 0) {
          this.currentItem = this.navItems[0];
          this.calculateVisibleItems();
          this.calculateTotalWidth();
        }
        // this.currentIndex = 0
        // this.offset = 0
        // this.visibleItems = 0
        // this.currentItem = null
        // this.totalWidth = 0
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mobile_xty.scss";
</style>